import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import {getWaterMarkName,waterMarkPath,watermark,} from './utils/index'
import store from './store'
Vue.use(Router)

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/base_msg',
      name: 'BaseMsg',
      component: (resolve) => require(['./views/BaseMsg'], resolve),
    },
    {
      path: '/base_image',
      name: 'BaseImage',
      component: (resolve) => require(['./views/BaseImage'], resolve),
    },
    {
      path: '/base_msg_ocr',
      name: 'BaseMsgOcr',
      component: (resolve) => require(['./views/BaseMsgOcrNew'], resolve),
    },
    {
      path: '/base_msg_hc',
      name: 'BaseMsgHc',
      component: (resolve) => require(['./views/BaseMsgHc'], resolve),
    },
    {
      path: '/base_msg_sd',
      name: 'BaseMsgSd',
      component: (resolve) => require(['./views/BaseMsgSd'], resolve),
    },
    {
      path: '/owner_same',
      name: 'OwnerSame',
      component: (resolve) => require(['./views/OwnerSame'], resolve),
    },
    {
      path: '/owner_same_hc',
      name: 'OwnerSameHc',
      component: (resolve) => require(['./views/OwnerSameHc'], resolve),
    },
    {
      path: '/owner_same_sd',
      name: 'OwnerSameSd',
      component: (resolve) => require(['./views/OwnerSameSd'], resolve),
    },
    {
      path: '/owner_same_ocr',
      name: 'OwnerSameOcr',
      component: (resolve) => require(['./views/OwnerSameOcrNew'], resolve),
    },
    {
      path: '/occupation_list',
      name: 'OccupationList',
      component: (resolve) => require(['./views/OccupationList'], resolve),
    },
    {
      path: '/occupation_list_new',
      name: 'OccupationListNew',
      component: (resolve) => require(['./views/OccupationListNew'], resolve),
    },
    {
      path: '/business_list',
      name: 'BusinessList',
      component: (resolve) => require(['./views/BusinessList'], resolve),
    },
    {
      path: '/holder_msg',
      name: 'HolderMsg',
      component: (resolve) => require(['./views/HolderMsg'], resolve),
    },

    {
      path: '/vehicle_model',
      name: 'VehicleModel',
      component: (resolve) => require(['./views/VehicleModel'], resolve),
    },
    {
      path: '/vehicle_select',
      name: 'VehicleSelect',
      component: (resolve) => require(['./views/VehicleSelect'], resolve),
    },
    {
      path: '/adujust_insurance',
      name: 'AdujustInsurance',
      component: (resolve) => require(['./views/Insurance'], resolve),
    },
    {
      path: '/adujust_insurance_energy',
      name: 'AdujustInsuranceEnergy',
      meta: {
        keepAlive: true,
      },
      component: (resolve) => require(['./views/InsuranceEnergy'], resolve),
    },
    {
      path: '/charging_pile',
      name: 'ChargingPile',
      component: (resolve) => require(['./views/ChargingPile'], resolve),
    },
    {
      path: '/status_bar',
      name: 'StatusBar',
      component: (resolve) => require(['./components/StatusBar'], resolve),
    },
    {
      path: '/submit_order',
      name: 'SubmitOrder',
      component: (resolve) => require(['./views/SubmitOrder'], resolve),
      children: [
        // {
        //   path: '/submit_order/instruction',
        //   name: 'Instruction',
        //   component: resolve => require(['./views/Instruction'], resolve),
        // },
        {
          path: '/submit_order/InstructionNew',
          name: 'InstructionNew',
          component: (resolve) => require(['./views/InstructionNew'], resolve),
        },
      ],
    },
    {
      path: '/upload_img',
      name: 'UploadImage',
      component: (resolve) => require(['./views/UploadImage'], resolve),
    },
    {
      path: '/upload_success',
      name: 'UpSuccess',
      component: (resolve) => require(['./views/UpSuccess'], resolve),
    },
    {
      path: '/payorder',
      name: 'PayOrder',
      component: (resolve) => require(['./views/PayOrder'], resolve),
    },
    {
      path: '/elecpage',
      name: 'ElecPage',
      component: (resolve) => require(['./views/ElecPage'], resolve),
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: (resolve) => require(['./views/privacy'], resolve),
    },
    {
      path: '/policy_list',
      name: 'policy_list',
      component: (resolve) => require(['./views/license_plate_modification/policy_list'], resolve),
    },
    {
      path: '/policy_detail',
      name: 'policy_detail',
      component: (resolve) => require(['./views/license_plate_modification/policy_detail'], resolve),
    },
    {
      path: '/license_modification',
      name: 'license_modification',
      component: (resolve) => require(['./views/license_plate_modification/license_modification'], resolve),
    },
    {
      path: '/modification_success',
      name: 'modification_success',
      component: (resolve) => require(['./views/license_plate_modification/modification_success'], resolve),
    },
    {
      path: '/check_car',
      name: 'check_car',
      component: (resolve) => require(['./views/CheckCar'], resolve),
    },
    // {
    //   path: '/title',
    //   name: 'title',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/navBar.vue')
    // }
  ],
})

router.beforeEach((to, from, next) => {
  if (to.path) {
    _hmt.push(['_trackPageview', '/#' + to.fullPath]);
    const waterMarkName = getWaterMarkName(store.state.quote.quoteInfo.base.operatorCode);
    const pathname = to.path;
    if ((waterMarkPath.includes(pathname)) && waterMarkName) {
        watermark.set(waterMarkName)
    } else {
        watermark.del()
    }
  }
  next()
})

export default router
